import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import {
  openEditModal,
  openViewModal,
} from "../../store/reducers/frasesRespuesta/frasesRespuesta.reducer";
import { getFraseRespuestaByIdThunk } from "../../store/reducers/frasesRespuesta/frasesRespuesta.thunks";

const FraseRespuestaActions = ({ fraseRespuesta }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    // Obtener los detalles completos de la frase respuesta primero
    await dispatch(getFraseRespuestaByIdThunk(fraseRespuesta.id));
    dispatch(
      openEditModal(),
    );
  };

  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getFraseRespuestaByIdThunk(fraseRespuesta.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FraseRespuestaActions;
